<template>
    <div class="col-12 col-md-5" v-if="!hide">
        <div class="content tags">
            <div class="h5 title">{{$t('views.audience.sections.tags.title')}}</div>
            <ul class="stats">
                <li class="stat" v-for="(count, tag) in audience.stats.tags" :key="tag" @click.stop="openProspects(tag)">
                    <div class="icon-tag-pos"></div>
                    <div class="name">{{tag}}</div>
                    <div class="value">{{formatNumber(count)}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAudienceStore } from '@/stores/audience';
    import { formatNumber } from '@/utils/formatting';

    export default {
        name: "AudienceTags",
        emits: ['update-visibility'],
        computed: {
            ...mapState(useAudienceStore, ['audience']),
            hide() {
                return !this.audience?.stats?.tags || Object.keys(this.audience.stats.tags).length < 1;
            }
        },
        methods: {
            formatNumber,
            openProspects(tag) {
                this.$router.push({
                    name: 'audienceProspects',
                    query: { 
                        prospectOptions: JSON.stringify({
                            reset: true,
                            options: {
                                tags: [tag]
                            }
                        })
                    }
                });
            }
        },
        watch: {
            hide() {
                this.$emit('update-visibility');
            }
        }
    }
</script>